import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IonImg } from '@ionic/angular/standalone';
import { SlipComponentStatusComponent } from '../slip-component-status/slip-component-status.component';
import { ComponentStatus, ComponentType } from '../student-slip-modal.store';

@Component({
  selector: 'app-slip-component-header',
  templateUrl: './slip-component-header.component.html',
  styleUrls: ['./slip-component-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SlipComponentStatusComponent, IonImg]
})
export class SlipComponentHeaderComponent {
  iconName: string;
  legend: string;
  @Input() status: ComponentStatus;
  private typeBacking: ComponentType;
  @Input()
  public set type(value: ComponentType) {
    this.typeBacking = value;
    switch (value) {
      case 'consent':
        this.iconName = 'checkbox-icon.svg';
        this.legend = 'Consent';
        break;
      case 'questions':
        this.iconName = 'questions.svg';
        this.legend = 'Questions';
        break;
      case 'item-choices':
        this.iconName = 'item-choices.svg';
        this.legend = 'Item Choices';
        break;
      default:
        this.iconName = 'payment-request.svg';
        this.legend = 'Payment';
    }
  }
  public get type(): ComponentType {
    return this.typeBacking;
  }
}
